import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectUpiPurchaseData,
  selectUserStatus,
} from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { sendDeferredUpiPurchaseEventsAction } from 'modules/purchase/redux/actions/common'

export const useUpiPaymentCompletion = (isTrackingReady: boolean): void => {
  const dispatch: TAppDispatch = useDispatch()
  const userStatus = useSelector(selectUserStatus)
  const upiPurchaseData = useSelector(selectUpiPurchaseData)

  const completedSubscriptionIdRef = useRef('')

  const hasSubscription = !!userStatus?.hasSubscription

  useEffect(() => {
    if (!isTrackingReady || !upiPurchaseData || !hasSubscription) return

    if (completedSubscriptionIdRef.current === upiPurchaseData.subscriptionId) {
      return
    }

    completedSubscriptionIdRef.current = upiPurchaseData.subscriptionId
    dispatch(sendDeferredUpiPurchaseEventsAction())
  }, [dispatch, hasSubscription, isTrackingReady, upiPurchaseData])
}
